module.exports = __webpack_public_path__ + "img/data-transfer-horizontal.f9b1c05e.svg";